<div class="main-container w-100 h-100 d-flex flex-column">
  <app-header class="position-fixed no-print" role="banner"></app-header>
  <router-outlet></router-outlet>
  <app-footer
    *ngIf="displayFooter(currentRoute)"
    class="position-relative no-print"
    role="contentinfo"
  ></app-footer>
</div>
